import { PDFDownloadLink } from "@react-pdf/renderer";
import axios from "axios";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { Container, Form } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import baseURL from "./../../../../Url/NodeBaseURL";
import "./../Sales/SalesForm.css";
import CustomerDetails from "./CustomerDetails";
import InvoiceDetails from "./InvoiceDetails";
import "./OrderForm.css";
import PaymentDetails from "./PaymentDetails";
import ProductDetails from "./ProductDetails";
import ProductTable from "./ProductTable";
import SalesFormSection from "./SalesForm3Section";
// import PDFLayout from "./TaxInvoiceA4";
import Salesorderform from "./SalesOrder";
import useCalculations from "./hooks/useCalculations";
import useProductHandlers from "./hooks/useProductHandlers";

const SalesForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showPDFDownload, setShowPDFDownload] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [metal, setMetal] = useState("");
  const [selectedMobile, setSelectedMobile] = useState("");
  const [discountAmount, setDiscountAmount] = useState(0);
  const [currentOrderIndex, setCurrentOrderIndex] = useState(-1);
  const [savedNetPayableAmount, setSavedNetPayableAmount] = useState(0);
  const [isManualNetPayableSet, setIsManualNetPayableSet] = useState(false);
  const setNetPayableEditableRef = useRef(null);
  const mobileRef = useRef(null); // Reference to Mobile input field in CustomerDetails
  const [sortedOrders, setSortedOrders] = useState([]);
  const isLoadingOrderRef = useRef(false);
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get(`${baseURL}/get/repair-details`);
        const allRepairs = response.data;

        // Group by order_number
        const grouped = {};
        for (const entry of allRepairs) {
          if (!grouped[entry.order_number]) {
            grouped[entry.order_number] = [];
          }
          grouped[entry.order_number].push(entry);
        }

        // Convert to array of { order_number, date, entries: [...] }
        const groupedOrders = Object.keys(grouped).map((orderNum) => {
          return {
            order_number: orderNum,
            date: grouped[orderNum][0].date,
            entries: grouped[orderNum],
          };
        });

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const sorted = groupedOrders.sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          if (dateA.getTime() !== dateB.getTime()) {
            return dateB - dateA;
          }
          const numA = parseInt(a.order_number.replace(/\D/g, "")) || 0;
          const numB = parseInt(b.order_number.replace(/\D/g, "")) || 0;
          return numB - numA;
        });

        setSortedOrders(sorted);
      } catch (err) {
        console.error("Failed to fetch orders:", err);
      }
    };

    fetchOrders();
  }, []);

  const loadOrderData = async (orderNumber) => {
    if (isLoadingOrderRef.current) {
      console.log("Already loading order data, skipping...");
      return;
    }
    
    isLoadingOrderRef.current = true;
    try {
      
      const response = await axios.get(
        `${baseURL}/get-order-details/${orderNumber}`
      );
      const { uniqueData, repeatedData } = response.data;


      if (!uniqueData) return;
      
      // Parse advance amount from uniqueData if it exists
      let parsedAdvanceEntries = [];
      if (uniqueData.advance_amount) {
        try {
          parsedAdvanceEntries = JSON.parse(uniqueData.advance_amount);
        } catch (e) {
          console.error("Error parsing advance_amount:", e);
          parsedAdvanceEntries = [];
        }
      }
      
      setFormData((prev) => ({
        ...prev,
        order_number: uniqueData.order_number || "",
        date: uniqueData.date
          ? (() => {
              // Preserve time if it exists, otherwise use date only
              const dateObj = new Date(uniqueData.date);
              if (isNaN(dateObj.getTime())) return "";
              
              // Check if the original date string has time component
              if (uniqueData.date.includes("T") || uniqueData.date.includes(" ")) {
                // Has time, format as ISO string
                const year = dateObj.getFullYear();
                const month = String(dateObj.getMonth() + 1).padStart(2, "0");
                const day = String(dateObj.getDate()).padStart(2, "0");
                const hours = String(dateObj.getHours()).padStart(2, "0");
                const minutes = String(dateObj.getMinutes()).padStart(2, "0");
                const seconds = String(dateObj.getSeconds()).padStart(2, "0");
                return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
              } else {
                // Date only, format as YYYY-MM-DD
                return dateObj.toLocaleDateString("en-CA", {
                  timeZone: "Asia/Kolkata",
                });
              }
            })()
          : "",
        customer_id: uniqueData.customer_id || "",
        account_name: uniqueData.account_name || "",
        mobile: uniqueData.mobile || "",
        email: uniqueData.email || "",
        address1: uniqueData.address1 || "",
        address2: uniqueData.address2 || "",
        city: uniqueData.city || "",
        pincode: uniqueData.pincode || "",
        state: uniqueData.state || "",
        state_code: uniqueData.state_code || "",
        aadhar_card: uniqueData.aadhar_card || "",
        gst_in: uniqueData.gst_in || "",
        pan_card: uniqueData.pan_card || "",
        terms: uniqueData.terms || "",
        cash_amt: parseFloat(uniqueData.cash_amount || 0),
        card_amt: parseFloat(uniqueData.card_amt || 0),
        online_amt: parseFloat(uniqueData.online_amt || 0),
        cheque_amt: parseFloat(uniqueData.chq_amt || 0),
        net_amt: parseFloat(uniqueData.net_amount || 0),
        tax_amt: parseFloat(uniqueData.tax_amount || 0),
        total_amt: parseFloat(uniqueData.taxable_amount || 0),
        round_off: 0, // add if available
      }));

      const filteredData = repeatedData?.filter(
        item => item.transaction_status === "Orders"
      ) || [];

      setOrderDetails(filteredData);

      
      // Set advance entries from loaded data
      setAdvanceEntries(parsedAdvanceEntries);
      setNewAdvanceEntries([]); // Clear new entries when loading existing order
      
      // Note: currentOrderIndex is set by the useEffect hook above
      
    } catch (error) {
      console.error("Error fetching invoice:", error);
    } finally {
      isLoadingOrderRef.current = false;
    }
  };
  const navigateToPreviousOrder = async () => {
    if (currentOrderIndex > 0) {
      const prevOrder = sortedOrders[currentOrderIndex - 1];
      await loadOrderData(prevOrder.order_number);
      setCurrentOrderIndex(currentOrderIndex - 1);
    }
  };
  const navigateToNextOrder = async () => {
    if (currentOrderIndex < sortedOrders.length - 1) {
      const nextOrder = sortedOrders[currentOrderIndex + 1];
      await loadOrderData(nextOrder.order_number);
      setCurrentOrderIndex(currentOrderIndex + 1);
    }
  };

  const navigateToFirstOrder = async () => {
    if (sortedOrders.length > 0) {
      const firstOrder = sortedOrders[0];
      await loadOrderData(firstOrder.order_number);
      setCurrentOrderIndex(0);
    }
  };

  const navigateToLastOrder = async () => {
    if (sortedOrders.length > 0) {
      const lastIndex = sortedOrders.length - 1;
      const lastOrder = sortedOrders[lastIndex];
      await loadOrderData(lastOrder.order_number);
      setCurrentOrderIndex(lastIndex);
    }
  };

  const [oldSalesData, setOldSalesData] = useState(
    JSON.parse(localStorage.getItem("oldSalesData")) || []
  );

  const [schemeSalesData, setSchemeSalesData] = useState(
    JSON.parse(localStorage.getItem("schemeSalesData")) || []
  );

  useEffect(() => {
    localStorage.setItem("oldSalesData", JSON.stringify(oldSalesData));
  }, [oldSalesData]);

  useEffect(() => {
    localStorage.setItem("schemeSalesData", JSON.stringify(schemeSalesData));
  }, [schemeSalesData]);

  const [orderDetails, setOrderDetails] = useState(
    JSON.parse(localStorage.getItem("orderDetails")) || []
  );

  const [paymentDetails, setPaymentDetails] = useState(
    JSON.parse(localStorage.getItem("paymentDetails")) || {
      cash_amount: 0,
      card_amt: 0,
      chq: "",
      chq_amt: 0,
      online: "",
      online_amt: 0,
    }
  );
  const getTodayDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };


  const [advanceEntries, setAdvanceEntries] = useState([]);
  const [newAdvanceEntries, setNewAdvanceEntries] = useState([]);
  const [newAdvance, setNewAdvance] = useState({
    amount: "",
    date: getTodayDate(),
    paymentMethod: "",
  });

  const {
    formData,
    setFormData,
    products,
    data,
    isQtyEditable,
    handleChange,
    handleBarcodeChange,
    handleProductChange,
    handleProductNameChange,
    handleMetalTypeChange,
    handleDesignNameChange,
    filteredDesignOptions,
    filteredPurityOptions,
    filteredMetalTypes,
    uniqueProducts,
    metaltypeOptions,
    categoryOptions,
    subcategoryOptions,
    designOptions,
    purityOptions,
    isBarcodeSelected,
    handleImageChange,
    image,
    fileInputRef,
    clearImage,
    captureImage,
    setShowWebcam,
    showWebcam,
    webcamRef,
    setShowOptions,
    showOptions,
    advance_amt,
    isManualTotalPriceChange,
    setIsManualTotalPriceChange,
    isTotalPriceCleared,
    setIsTotalPriceCleared,
  } = useProductHandlers();

  useCalculations(formData, setFormData);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await fetch(`${baseURL}/get/account-details`);
        if (!response.ok) {
          throw new Error("Failed to fetch customers");
        }
        const result = await response.json();
        const filteredCustomers = result.filter(
          (item) =>
            item.account_group === "CUSTOMERS" ||
            item.account_group === "SUPPLIERS"
        );
        setCustomers(filteredCustomers);
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };

    fetchCustomers();
  }, []);

  useEffect(() => {
    const fetchLastInvoiceNumber = async () => {
      try {
        const response = await axios.get(`${baseURL}/lastOrderNumber`);
        setFormData((prev) => ({
          ...prev,
          // Only set order_number if it's not already set (i.e., not from navigation)
          order_number: prev.order_number || response.data.lastOrderNumber,
        }));
      } catch (error) {
        console.error("Error fetching order number:", error);
      }
    };

    fetchLastInvoiceNumber();
  }, []);

  useEffect(() => {
    localStorage.setItem("orderDetails", JSON.stringify(orderDetails));
  }, [orderDetails]);

  useEffect(() => {
    localStorage.setItem("paymentDetails", JSON.stringify(paymentDetails));
  }, [paymentDetails]);

  const [uniqueInvoice, setUniqueInvoice] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const [saveLoading, setSaveLoading] = useState(false);

  const [returnData, setReturnData] = useState({
    invoice_number: "",
  });

  useEffect(() => {
  if (!returnData.date) {
    const nowUTC = new Date();
    const nowIST = new Date(nowUTC.getTime() + 5.5 * 60 * 60 * 1000);

    setReturnData((prev) => ({
      ...prev,
      date: formatDate(nowIST),
    }));
  }
}, [returnData, setReturnData]);

const formatDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};



  // Handle invoice number change
  const handleInvoiceChange = (e) => {
    const selectedInvoiceNumber = e.target.value;
    const selectedInvoice = filteredInvoices.find(
      (invoice) => invoice.invoice_number === selectedInvoiceNumber
    );

    if (selectedInvoice) {
      setReturnData({
        ...returnData,
        invoice_number: selectedInvoiceNumber,
        date: selectedInvoice.date ? formatDate(selectedInvoice.date) : "", // Format date
        terms: selectedInvoice.terms || "", // Set the terms from the selected invoice
      });
    } else {
      setReturnData({
        ...returnData,
        invoice_number: selectedInvoiceNumber,
        date: "",
        terms: "",
      });
    }
  };

  useEffect(() => {
    const fetchRepairs = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/get-unique-repair-details`
        );
        const filteredData = response.data.filter(
          (item) => item.transaction_status === "Sales"
        );
        setUniqueInvoice(filteredData);
        setFilteredInvoices(filteredData); // Initially, show all invoices
      } catch (error) {
        console.error("Error fetching repair details:", error);
      }
    };

    fetchRepairs();
  }, []);

  useEffect(() => {
    const fetchInvoiceDetails = async () => {
      if (!returnData.invoice_number) {
        setInvoiceDetails([]); // Ensure it's an empty array, not null
        return;
      }

      try {
        const response = await axios.get(
          `${baseURL}/getsales/${returnData.invoice_number}`
        );
        const filteredData = response.data.filter(
          (invoice) => invoice.status !== "Sale Returned"
        );

        setInvoiceDetails(filteredData || []); // Ensure it's always an array
        console.log("Fetched Invoice Details:", filteredData);
      } catch (error) {
        console.error(
          `Error fetching details for invoice ${returnData.invoice_number}:`,
          error
        );
        setInvoiceDetails([]); // Set empty array on error
      }
    };

    fetchInvoiceDetails();
  }, [returnData.invoice_number]);

  const [customerImage, setCustomerImage] = useState("");

  // Load order data when order_number is passed via location.state
  useEffect(() => {
    const orderNumberFromState = location.state?.order_number;
    if (orderNumberFromState && sortedOrders.length > 0) {
      console.log("🔍 DEBUG: Loading order from location.state", {
        orderNumberFromState,
        sortedOrdersLength: sortedOrders.length
      });
      loadOrderData(orderNumberFromState);
    }
  }, [location.state?.order_number, sortedOrders.length]);

  useEffect(() => {
    // Check if orderDetails are passed via navigation
    const vendorAssigned = location.state?.vendorAssigned;
    if (vendorAssigned) {
      setIsVendor(true);
    } else {
      setIsVendor(false);
    }
    const incomingOrderDetails = location.state?.orderDetails;
    if (incomingOrderDetails && incomingOrderDetails.length > 0) {
      const item = incomingOrderDetails[0];
      // Get date from location.state first, then from item.date, then fallback to empty string
      const dateFromState = location.state?.date;
      const dateFromItem = item.date 
        ? new Date(item.date).toLocaleDateString("en-CA", {
            timeZone: "Asia/Kolkata",
          })
        : "";
      const finalDate = dateFromState || dateFromItem || "";
      
      setFormData((prev) => ({
        ...prev,
        order_number: item.order_number ?? "",
        // Customer fields
        customer_id: item.customer_id ?? "",
        account_name: item.account_name ?? "",
        mobile: item.mobile ?? "",
        email: item.email ?? "",
        address1: item.address1 ?? "",
        address2: item.address2 ?? "",
        city: item.city ?? "",
        pincode: item.pincode ?? "",
        state: item.state ?? "",
        state_code: item.state_code ?? "",
        aadhar_card: item.aadhar_card ?? "",
        gst_in: item.gst_in ?? "",
        pan_card: item.pan_card ?? "",
        // Product fields
        category: item.category ?? "",
        code: item.code ?? "",
        metal_type: item.metal_type ?? "",
        product_name: item.product_name ?? "",
        design_name: item.design_name ?? "",
        pricing: item.pricing ?? "",
        purity: item.purity ?? "",
        selling_purity:item.selling_purity??"",
        custom_purity:item.custom_purity??"",
        gross_weight: item.gross_weight ?? "",
        stone_weight: item.stone_weight ?? "",
        stone_price: item.stone_price ?? "",
        weight_bw: item.weight_bw ?? "",
        va_on: item.va_on ?? "",
        va_percent: item.va_percent ?? "",
        wastage_weight: item.wastage_weight ?? "",
        total_weight_av: item.total_weight_av ?? "",
        size: item.size ?? "",
        rate_type: item.rate_type ?? "",
        rate: item.rate ?? "",
        rate_amt: item.rate_amt ?? "",
        mc_on: item.mc_on ?? "",
        mc_per_gram: item.mc_per_gram ?? "",
        making_charges: item.making_charges ?? "",
        hm_charges: item.hm_charges ?? "",
        tax_percent: item.tax_percent ?? "",
        tax_amt: item.tax_amt ?? "",
        total_price: item.total_price ?? "",
        remarks: item.remarks ?? "",
        qty: item.qty ?? "",
        imagePreview: item.imagePreview ?? "",
        // Set date from location.state first, then from item, then empty string
        date: finalDate,
      }));
      
      // Set all order details for the product table
      setOrderDetails(incomingOrderDetails);
    }
  }, [location.state]);

  // Set today's date with time when creating a new order (no location.state and no date in formData)
  useEffect(() => {
    const hasLocationState = location.state?.orderDetails || location.state?.order_number;
    if (!hasLocationState) {
      setFormData((prev) => {
        // Only set date if it's empty
        if (!prev.date || prev.date === "") {
          const now = new Date();
          // Get IST time
          const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC+5:30
          const istTime = new Date(now.getTime() + istOffset);
          // Format as ISO string with time: YYYY-MM-DDTHH:mm:ss
          const year = istTime.getUTCFullYear();
          const month = String(istTime.getUTCMonth() + 1).padStart(2, "0");
          const day = String(istTime.getUTCDate()).padStart(2, "0");
          const hours = String(istTime.getUTCHours()).padStart(2, "0");
          const minutes = String(istTime.getUTCMinutes()).padStart(2, "0");
          const seconds = String(istTime.getUTCSeconds()).padStart(2, "0");
          const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
          return {
            ...prev,
            date: formattedDateTime,
          };
        }
        return prev;
      });
    }
  }, [location.state, setFormData]);

  // Set currentOrderIndex when sortedOrders and formData.order_number are available
  useEffect(() => {
    if (sortedOrders.length > 0 && formData.order_number && currentOrderIndex === -1 && !isLoadingOrderRef.current) {
      console.log("Setting currentOrderIndex for order:", formData.order_number);
      console.log("Available orders:", sortedOrders.map(o => o.order_number));
      const orderIndex = sortedOrders.findIndex(
        (order) => order.order_number === formData.order_number
      );
      console.log("Found order index:", orderIndex);
      if (orderIndex !== -1) {
        setCurrentOrderIndex(orderIndex);
        console.log("Set currentOrderIndex to:", orderIndex);
        // Don't call loadOrderData here if we already have order data from navigation
        // loadOrderData will be called by the navigation handlers when needed
      } else {
        console.log("Order not found in sortedOrders:", formData.order_number);
      }
    }
  }, [sortedOrders, formData.order_number]);

  const handleCustomerChange = (customerId) => {
    const customer = customers.find(
      (cust) => String(cust.account_id) === String(customerId)
    );
    console.log("customer", customer);
    if (customer) {
      setFormData((prevData) => ({
        ...prevData,
        customer_id: customerId,
        account_name: customer.account_name || "",
        mobile: customer.mobile || "",
        email: customer.email || "",
        address1: customer.address1 || "",
        address2: customer.address2 || "",
        city: customer.city || "",
        pincode: customer.pincode || "",
        state: customer.state || "",
        state_code: customer.state_code || "",
        aadhar_card: customer.aadhar_card || "",
        gst_in: customer.gst_in || "",
        pan_card: customer.pan_card || "",
        invoice_number: prevData.invoice_number || "",
      }));

      setSelectedMobile(customer.mobile || "");

      const filtered = uniqueInvoice.filter(
        (invoice) =>
          (invoice.customer_name &&
            customer.account_name &&
            invoice.customer_name.toLowerCase() ===
              customer.account_name.toLowerCase()) ||
          invoice.mobile === customer.mobile
      );
      setFilteredInvoices(filtered);

      // 👉 Set the image URL if available
      if (customer.images && customer.images.length > 0) {
        // setCustomerImage(customer.images[0].url);
        setCustomerImage(customer.images[0].filename);
        console.log("image", customer.images[0].filename);
        console.log("image", customer.images[0].url);
      } else {
        setCustomerImage(""); // clear if no image
      }
    } else {
      // reset logic
      setFormData((prevData) => ({
        ...prevData,
        customer_id: "",
        account_name: "",
        mobile: "",
        email: "",
        address1: "",
        address2: "",
        city: "",
        pincode: "",
        state: "",
        state_code: "",
        aadhar_card: "",
        gst_in: "",
        pan_card: "",
        invoice_number: prevData.invoice_number || "",
      }));
      setSelectedMobile("");
      setFilteredInvoices(uniqueInvoice);
      setCustomerImage("");
    }
  };

  const handleImageUpload = (file) => {
    setFormData((prev) => ({
      ...prev,
      product_image: file, // Store the uploaded image in formData
    }));
  };
  const handleDiscountChange = (e) => {
    const discountValue = parseFloat(e.target.value) || "";

    setDiscount(discountValue);
    setManualNetAmount(0); // Reset manualNetAmount to exit manual mode
    setIsManualNetMode(false); // Ensure we're in normal discount mode
    applyDiscountToOrderDetails(discountValue); // Recalculate with new discount
  };
  const [editIndex, setEditIndex] = useState(null);
  const [isVendor, setIsVendor]=useState(false);
  const [discount, setDiscount] = useState();

  const [manualNetAmount, setManualNetAmount] = useState(0);
  const [manualNetPayAmount, setManualNetPayAmount] = useState(0);
  const [isManualNetMode, setIsManualNetMode] = useState(false);

  // useEffect(() => {
  //   // if (tabId) {
  //   localStorage.setItem(`discount`, discount); // Save to localStorage when discount changes
  //   // }
  // }, [discount]);
  const applyDiscountToOrderDetails = (discountValue) => {
    console.log("=== OrderForm Debug - applyDiscountToOrderDetails ===");
    console.log("discountValue:", discountValue);
    
    const storedRepairDetails =
      JSON.parse(localStorage.getItem(`orderDetails`)) || [];
    
    console.log("storedRepairDetails before discount:", storedRepairDetails);

    const updatedOrderDetails = storedRepairDetails.map((item, index) => {
      const makingCharges = parseFloat(item.making_charges) || 0;
      const pieceCost = parseFloat(item.pieace_cost) || 0;
      const qty = parseFloat(item.qty) || 1;
      const taxPercent = parseFloat(item.tax_percent) || 1;
      const piece_taxable_amt = parseFloat(item.piece_taxable_amt) || 0;
      const rateAmt = parseFloat(item.rate_amt) || 0;
      const stonePrice = parseFloat(item.stone_price) || 0;
      const discountAmt = parseFloat(item.disscount) || 0;
      const hmCharges = parseFloat(item.hm_charges) || 0;
      const pricingType = item.pricing;
      const festivalDiscount = parseFloat(item.festival_discount) || 0;

      let calculatedDiscount = 0;

        if (pricingType === "By fixed") {
          const pieceTaxableAmt = pieceCost * qty;
          calculatedDiscount = parseFloat(((pieceTaxableAmt * discountValue) / 100).toFixed(10));

        const originalPieceTaxableAmt = item.original_piece_taxable_amt
          ? parseFloat(item.original_piece_taxable_amt)
          : pieceTaxableAmt;

        const updatedPieceTaxableAmt =
          originalPieceTaxableAmt - calculatedDiscount - festivalDiscount;
        const taxAmt = parseFloat(((taxPercent * updatedPieceTaxableAmt) / 100).toFixed(10));
        const totalPrice = parseFloat((updatedPieceTaxableAmt + taxAmt).toFixed(10));

        return {
          ...item,
          original_piece_taxable_amt: originalPieceTaxableAmt.toFixed(2),
          disscount: calculatedDiscount.toFixed(2),
          disscount_percentage: discountValue,
          piece_taxable_amt: updatedPieceTaxableAmt.toFixed(2),
          tax_amt: taxAmt.toFixed(2),
          total_price: totalPrice.toFixed(2),
        };
      } else {
        // Calculate discount based on the total amount before tax, not just making charges
        const totalBeforeDiscount = rateAmt + stonePrice + makingCharges + hmCharges;
        calculatedDiscount = parseFloat(((totalBeforeDiscount * discountValue) / 100).toFixed(10));

        console.log(`Item ${index} - By Weight calculation:`, {
          rateAmt,
          stonePrice,
          makingCharges,
          hmCharges,
          totalBeforeDiscount,
          discountValue,
          calculatedDiscount,
          festivalDiscount
        });

        const previousTotalPrice = parseFloat(item.total_price) || 0;
        const originalTotalPrice = item.original_total_price
          ? parseFloat(item.original_total_price)
          : previousTotalPrice;

        const totalBeforeTax =
          rateAmt +
          stonePrice +
          makingCharges +
          hmCharges -
          calculatedDiscount -
          festivalDiscount;
        const taxAmt = parseFloat(((totalBeforeTax * taxPercent) / 100).toFixed(10));
        const updatedTotalPrice = parseFloat((totalBeforeTax + taxAmt).toFixed(10));
        
        console.log(`Item ${index} - Final calculation:`, {
          totalBeforeTax,
          taxAmt,
          updatedTotalPrice,
          previousTotalPrice
        });

        return {
          ...item,
          original_total_price: originalTotalPrice.toFixed(2),
          disscount: calculatedDiscount.toFixed(2),
          disscount_percentage: discountValue,
          tax_amt: taxAmt.toFixed(2),
          total_price: updatedTotalPrice.toFixed(2),
        };
      }
    });

    console.log("=== OrderForm Debug - Final Results ===");
    console.log("updatedOrderDetails after discount:", updatedOrderDetails);
    
    // Calculate final totals
    const finalTotalAmount = updatedOrderDetails.reduce((sum, item) => sum + parseFloat(item.total_price) || 0, 0);
    const finalDiscountAmount = updatedOrderDetails.reduce((sum, item) => sum + parseFloat(item.disscount) || 0, 0);
    const finalTaxAmount = updatedOrderDetails.reduce((sum, item) => sum + parseFloat(item.tax_amt) || 0, 0);
    
    console.log("Final totals after discount application:");
    console.log("finalTotalAmount:", finalTotalAmount);
    console.log("finalDiscountAmount:", finalDiscountAmount);
    console.log("finalTaxAmount:", finalTaxAmount);

    setOrderDetails(updatedOrderDetails);
    localStorage.setItem(`orderDetails`, JSON.stringify(updatedOrderDetails));
  };

  const applyDiscountAmountToOrderDetails = async (discountAmount) => {
    // get the total making charge
    const totalMakingCharges = orderDetails.reduce(
      (sum, item) => sum + parseFloat(item.making_charges) || 0,
      0
    );

    // check what will the % of discount amount on total making charges
    const discountPercentage = (discountAmount / totalMakingCharges) * 100;

    // set the discount to the discount percentage
    setDiscount(discountPercentage);
    applyDiscountToOrderDetails(discountPercentage);
  };

  const [festivalShowModal, festivalSetShowModal] = useState(false);
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleFestivalShowModal = () => festivalSetShowModal(true);
  const handleFestivalCloseModal = () => festivalSetShowModal(false);
  const [appliedOffers, setAppliedOffers] = useState([]);
  const [appliedOffersFromAPI, setAppliedOffersFromAPI] = useState([]);
  const [orderDataLoaded, setOrderDataLoaded] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/offers`);
        const allOffers = response.data;

        const today = new Date();

        // Filter offers that are currently valid (within date range)
        const validOffers = allOffers.filter((offer) => {
          const validFrom = new Date(offer.valid_from);
          const validTo = new Date(offer.valid_to);
          const isDateValid = today >= validFrom && today <= validTo;
          const isNotUnapplied =
            !offer.offer_status ||
            offer.offer_status.toLowerCase() !== "unapplied";
          return isDateValid && isNotUnapplied;
        });
        // Separate applied and unapplied offers
        const appliedOffersAPI = validOffers.filter(
          (offer) =>
            offer.offer_status && offer.offer_status.toLowerCase() === "applied"
        );
        const availableOffers = validOffers.filter(
          (offer) =>
            !offer.offer_status ||
            offer.offer_status.toLowerCase() === "available" ||
            offer.offer_status === ""
        );
        // const unappliedOffers = validOffers.filter(
        //   (offer) =>
        //     !offer.offer_status ||
        //     offer.offer_status.toLowerCase() === "unapplied"
        // );

        setOffers(availableOffers);
        setAppliedOffersFromAPI(appliedOffersAPI);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching offers:", error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (appliedOffersFromAPI.length > 0 && orderDetails.length > 0) {
      // Clear previously applied offers when navigating to a new invoice
      if (orderDataLoaded) {
        setAppliedOffers([]);
        setOrderDataLoaded(false);
      }

      appliedOffersFromAPI.forEach((offer, index) => {
        // Prevent re-applying the same offer
        const alreadyApplied = appliedOffers.some(
          (applied) =>
            (applied.offer_id || applied._id) === (offer.offer_id || offer._id)
        );
        if (!alreadyApplied) {
          handleApply(offer, index);
        }
      });
    }
  }, [appliedOffersFromAPI, orderDetails, orderDataLoaded]);
  const [isAnyOfferApplied, setIsAnyOfferApplied] = useState(false);

  const handleApply = (selectedOffer, offerIndex) => {
    const storedOrderDetails =
      JSON.parse(localStorage.getItem(`orderDetails`)) || [];
    const currentOfferKey = `${
      selectedOffer.offer_id || selectedOffer._id
    }_${offerIndex}`;

    // Use current state if localStorage is empty but state has data
    let updatedOrderDetails =
      storedOrderDetails.length > 0
        ? [...storedOrderDetails]
        : [...orderDetails];

    // If no items to apply offer to, just mark the offer as applied
    if (updatedOrderDetails.length === 0) {
      setAppliedOffers((prev) => [...prev, selectedOffer]);
      setIsAnyOfferApplied(true);
      return;
    }

    updatedOrderDetails = updatedOrderDetails.map((item) => {
      const taxPercent = parseFloat(item.tax_percent) || 1;
      const pieceCost = parseFloat(item.pieace_cost) || 0;
      const qty = parseFloat(item.qty) || 1;
      const discountAmt = parseFloat(item.disscount) || 0;
      const pricingType = item.pricing;
      const rateAmt = parseFloat(item.rate_amt) || 0;
      const stonePrice = parseFloat(item.stone_price) || 0;
      const makingCharges = parseFloat(item.making_charges) || 0;
      const hmCharges = parseFloat(item.hm_charges) || 0;
      const grossWeight = parseFloat(item.gross_weight) || 0;

      const percentageDiscount =
        parseFloat(selectedOffer.discount_percentage) || 0;
      const rateDiscount = parseFloat(selectedOffer.discount_on_rate) || 0;
      const fixedPercentageDiscount =
        parseFloat(selectedOffer.discount_percent_fixed) || 0;
      const weightBasedDiscount = (rateDiscount / 10) * grossWeight;
      const totalDiscountValue =
        pricingType === "By fixed"
          ? fixedPercentageDiscount
          : percentageDiscount + weightBasedDiscount;

      if (pricingType === "By fixed") {
        const pieceTaxableAmt = pieceCost * qty;
        const originalPieceTaxableAmt = item.original_piece_taxable_amt
          ? parseFloat(item.original_piece_taxable_amt)
          : pieceTaxableAmt;

        const calculatedDiscount = (pieceTaxableAmt * totalDiscountValue) / 100;
        const updatedPieceTaxableAmt =
          originalPieceTaxableAmt - calculatedDiscount - discountAmt;
        const taxAmt = (taxPercent * updatedPieceTaxableAmt) / 100;
        const totalPrice = updatedPieceTaxableAmt + taxAmt;

        return {
          ...item,
          original_piece_taxable_amt: originalPieceTaxableAmt.toFixed(2),
          festival_discount: calculatedDiscount.toFixed(2),
          festival_discount_percentage: percentageDiscount.toFixed(2),
          festival_discount_on_rate: rateDiscount.toFixed(2),
          piece_taxable_amt: updatedPieceTaxableAmt.toFixed(2),
          tax_amt: taxAmt.toFixed(2),
          total_price: totalPrice.toFixed(2),
        };
      } else {
        const calculatedDiscount =
          (makingCharges * percentageDiscount) / 100 +
          (rateDiscount / 10) * grossWeight;
        const totalBeforeTax =
          rateAmt +
          stonePrice +
          makingCharges +
          hmCharges -
          calculatedDiscount -
          discountAmt;

        const taxAmt = (totalBeforeTax * taxPercent) / 100;
        const updatedTotalPrice = totalBeforeTax + taxAmt;

        return {
          ...item,
          original_total_price: item.original_total_price
            ? item.original_total_price
            : parseFloat(item.total_price).toFixed(2),
          festival_discount: calculatedDiscount.toFixed(2),
          festival_discount_percentage: percentageDiscount.toFixed(2),
          festival_discount_on_rate: rateDiscount.toFixed(2),
          tax_amt: taxAmt.toFixed(2),
          total_price: updatedTotalPrice.toFixed(2),
        };
      }
    });

    setOrderDetails(updatedOrderDetails);
    localStorage.setItem(`orderDetails`, JSON.stringify(updatedOrderDetails));

    // Mark the offer as applied
    setAppliedOffers((prev) => [...prev, selectedOffer]);
    setIsAnyOfferApplied(true);
  };

  // const handleDiscountChange = (e) => {
  //   const discountValue = parseFloat(e.target.value) || 0; // Default to 0 if empty or NaN
  //   if (discountValue > 15) {
  //     alert("Discount cannot be greater than 15%");
  //     return; // Prevent further execution
  //   }
  //   setDiscount(discountValue);

  //   const storedOrderDetails =
  //     JSON.parse(localStorage.getItem("orderDetails")) || [];

  //   const updatedOrderDetails = storedOrderDetails.map((item) => {
  //     const makingCharges = parseFloat(item.making_charges) || 0; // Default to 0 if NaN
  //     const calculatedDiscount = (makingCharges * discountValue) / 100;

  //     // Ensure `total_price` is a valid number
  //     const previousTotalPrice = parseFloat(item.total_price) || 0;

  //     // Store original total price if not already stored
  //     const originalTotalPrice = item.original_total_price
  //       ? parseFloat(item.original_total_price)
  //       : previousTotalPrice;

  //     // Calculate the updated total price after applying the discount
  //     const updatedTotalPrice = originalTotalPrice - calculatedDiscount;

  //     return {
  //       ...item,
  //       original_total_price: originalTotalPrice.toFixed(2), // Store original price
  //       disscount: calculatedDiscount.toFixed(2), // Corrected spelling
  //       total_price: updatedTotalPrice.toFixed(2), // Update total price
  //     };
  //   });

  //   // Update both state and localStorage
  //   setOrderDetails(updatedOrderDetails);
  //   localStorage.setItem("orderDetails", JSON.stringify(updatedOrderDetails));

  //   console.log("Updated Order Details:", updatedOrderDetails);
  // };

  // const handleDiscountAmountChange = (e) => {
  //   const amountValue = parseFloat(e.target.value) || 0;
  //   setDiscountAmount(amountValue);

  //   // Use the current state, not localStorage!
  //   const totalMakingCharges = orderDetails.reduce(
  //     (sum, item) => sum + (parseFloat(item.making_charges) || 0),
  //     0
  //   );

  //   // Calculate the new discount percentage
  //   const discountPerc =
  //     totalMakingCharges === 0 ? 0 : (amountValue / totalMakingCharges) * 100;
  //   setDiscount(discountPerc);

  //   // Update orderDetails with the new discount and percentage
  //   const updatedOrderDetails = orderDetails.map((item) => {
  //     const makingCharges = parseFloat(item.making_charges) || 0;
  //     const calculatedDiscount = (makingCharges * discountPerc) / 100;

  //     // Preserve original_total_price when applying discount for the first time
  //     const originalTotalPrice = item.original_total_price
  //       ? parseFloat(item.original_total_price)
  //       : parseFloat(item.total_price) || 0;

  //     // If discount is cleared (0%), reset total_price to original_total_price
  //     const updatedTotalPrice =
  //       discountPerc === 0
  //         ? originalTotalPrice
  //         : originalTotalPrice - calculatedDiscount;

  //     return {
  //       ...item,
  //       original_total_price: originalTotalPrice.toFixed(2),
  //       disscount: calculatedDiscount.toFixed(2),
  //       disscount_percentage: discountPerc,
  //       total_price: updatedTotalPrice.toFixed(2),
  //     };
  //   });

  //   setOrderDetails(updatedOrderDetails);
  //   // No need to set localStorage here, your useEffect will handle it
  // };
  const applyFestivalDiscountToAllProducts = () => {
    console.log("applyFestivalDiscountToAllProducts called");
    console.log("offers:", offers);
    console.log("appliedOffersFromAPI:", appliedOffersFromAPI);
    console.log("orderDetails:", orderDetails);

    if (offers.length === 0 && appliedOffersFromAPI.length === 0) {
      console.log("No offers available");
      return;
    }

    // Use applied offers from API if available, otherwise use first offer
    const activeOffer =
      appliedOffersFromAPI.length > 0
        ? appliedOffersFromAPI[0]
        : offers.length > 0
        ? offers[0]
        : null;

    console.log("Active offer:", activeOffer);

    if (!activeOffer) {
      console.log("No active offer found");
      return;
    }

    // Use the existing handleApply logic which is already working correctly
    const storedOrderDetails =
      JSON.parse(localStorage.getItem(`orderDetails`)) || [];
    let updatedOrderDetails =
      storedOrderDetails.length > 0
        ? [...storedOrderDetails]
        : [...orderDetails];

    console.log("Products to update:", updatedOrderDetails.length);

    if (updatedOrderDetails.length === 0) {
      console.log("No products to update");
      return;
    }

    updatedOrderDetails = updatedOrderDetails.map((item, index) => {
      console.log(`Processing product ${index + 1}:`, item);
      const taxPercent = parseFloat(item.tax_percent) || 1;
      const pieceCost = parseFloat(item.pieace_cost) || 0;
      const qty = parseFloat(item.qty) || 1;
      const discountAmt = parseFloat(item.disscount) || 0;
      const pricingType = item.pricing;
      const rateAmt = parseFloat(item.rate_amt) || 0;
      const stonePrice = parseFloat(item.stone_price) || 0;
      const makingCharges = parseFloat(item.making_charges) || 0;
      const hmCharges = parseFloat(item.hm_charges) || 0;
      const grossWeight = parseFloat(item.gross_weight) || 0;

      const percentageDiscount =
        parseFloat(activeOffer.discount_percentage) || 0;
      const rateDiscount = parseFloat(activeOffer.discount_on_rate) || 0;
      const fixedPercentageDiscount =
        parseFloat(activeOffer.discount_percent_fixed) || 0;
      const weightBasedDiscount = (rateDiscount / 10) * grossWeight;
      const totalDiscountValue =
        pricingType === "By fixed"
          ? fixedPercentageDiscount
          : percentageDiscount + weightBasedDiscount;

      if (pricingType === "By fixed") {
        const pieceTaxableAmt = pieceCost * qty;
        const originalPieceTaxableAmt = item.original_piece_taxable_amt
          ? parseFloat(item.original_piece_taxable_amt)
          : pieceTaxableAmt;

        const calculatedDiscount = (pieceTaxableAmt * totalDiscountValue) / 100;
        const updatedPieceTaxableAmt =
          originalPieceTaxableAmt - calculatedDiscount - discountAmt;
        const taxAmt = (taxPercent * updatedPieceTaxableAmt) / 100;
        const totalPrice = updatedPieceTaxableAmt + taxAmt;

        return {
          ...item,
          original_piece_taxable_amt: originalPieceTaxableAmt.toFixed(2),
          festival_discount: calculatedDiscount.toFixed(2),
          festival_discount_percentage: percentageDiscount.toFixed(2),
          festival_discount_on_rate: rateDiscount.toFixed(2),
          piece_taxable_amt: updatedPieceTaxableAmt.toFixed(2),
          tax_amt: taxAmt.toFixed(2),
          total_price: totalPrice.toFixed(2),
        };
      } else {
        const calculatedDiscount =
          (makingCharges * percentageDiscount) / 100 +
          (rateDiscount / 10) * grossWeight;
        const totalBeforeTax =
          rateAmt +
          stonePrice +
          makingCharges +
          hmCharges -
          calculatedDiscount -
          discountAmt;

        const taxAmt = (totalBeforeTax * taxPercent) / 100;
        const updatedTotalPrice = totalBeforeTax + taxAmt;

        return {
          ...item,
          original_total_price: item.original_total_price
            ? item.original_total_price
            : parseFloat(item.total_price).toFixed(2),
          festival_discount: calculatedDiscount.toFixed(2),
          festival_discount_percentage: percentageDiscount.toFixed(2),
          festival_discount_on_rate: rateDiscount.toFixed(2),
          tax_amt: taxAmt.toFixed(2),
          total_price: updatedTotalPrice.toFixed(2),
        };
      }
    });

    setOrderDetails(updatedOrderDetails);
    localStorage.setItem(`orderDetails`, JSON.stringify(updatedOrderDetails));
  };
  const validateFields = useCallback(async() => {
    const errors = [];

    // Validate Barcode/Rbarcode
    if (!formData.code || formData.code.trim() === "") {
      errors.push("BarCode/Rbarcode is required");
    }

    // Validate Gross Weight for "By Weight" pricing
    if (formData.pricing !== "By fixed" && formData.pricing !== "By Running Tag") {
      if (!formData.gross_weight || parseFloat(formData.gross_weight) <= 0) {
        errors.push("Gross Weight is required and must be greater than 0");
      }
    }

    // Validate Rate Type Flexible requires remarks
    if (formData.rate_type === "Flexible" && !formData.remarks?.trim()) {
      errors.push("Please add remarks when Rate Type is Flexible");
    }
    if(formData.pricing=== "By Running Tag"){
      try {
        const response = await fetch(`${baseURL}/get/opening-tags-entry`);
        if (!response.ok) throw new Error("Failed to fetch tag data");

        const result = await response.json();
        const tags = result.result || [];

        const tag = tags.find(
          (t) => String(t.PCode_BarCode) === String(formData.code)
        );

        if (tag) {
          if (Number(tag.rem_pcs) < Number(formData.qty)) {
            errors.push(
              `Qty cannot exceed available pcs (${tag.rem_pcs} pcs available)`
            );
          }
        }

      } catch (err) {
        console.error("TAG validation failed:", err);
        errors.push("Error validating tag availability");
      }
    }    

    if (errors.length > 0) {
      alert(errors.join("\n"));
      return false;
    }

    return true;
  });

  const handleAdd =  useCallback(async () => {
    const isValid = await validateFields();  //Validate fields before adding

    if (!isValid) {
      return null;   
    }

    const wasManualLocked = isManualNetPayableSet;
    const storedOrderDetails =
      JSON.parse(localStorage.getItem(`orderDetails`)) || [];

    // Create the new product
    const newProduct = {
      ...formData,
      pieace_cost:
        formData.pieace_cost && parseFloat(formData.pieace_cost) > 0
          ? parseFloat(formData.pieace_cost).toFixed(2)
          : null,
      rate:
        formData.rate && parseFloat(formData.rate) > 0
          ? parseFloat(formData.rate).toFixed(2)
          : "",
      imagePreview: formData.imagePreview,
      client_visibility: formData.client_visibility,
    };

    // Add new repair detail
    const updatedOrderDetails = [...orderDetails, newProduct];

    setOrderDetails(updatedOrderDetails);
    localStorage.setItem(`orderDetails`, JSON.stringify(updatedOrderDetails));

    // Reset form data
    setFormData((prevData) => ({
      ...prevData,
      disscount: "",
      disscount_percentage: "",
      pieace_cost: "",
      imagePreview: null,
      // order_status: "Delivered",
      piece_taxable_amt: "",
      festival_discount: "",
    }));

    resetProductFields();

    // When a new product is added after a manual Net Payable save,
    // exit manual-net mode to avoid compounding discount calculations
    setIsManualNetMode(false);
    setManualNetAmount(0);
    setIsManualNetPayableSet(false);
    setSavedNetPayableAmount(0);

    // Make net payable amount editable when product is added
    if (setNetPayableEditableRef.current) {
      setNetPayableEditableRef.current();
    }

    // Apply festival discount to all products if offers are available
    if (offers.length > 0 || appliedOffersFromAPI.length > 0) {
      applyFestivalDiscountToAllProducts();
    }

    // If manual net payable had been locked previously, clear the discount
    // so it doesn't stack with the newly added product
    if (wasManualLocked) {
      setDiscount(0);
      applyDiscountToOrderDetails(0);
    } else if (discount !== "" && !isNaN(parseFloat(discount))) {
      // Otherwise, re-apply existing percentage uniformly
      applyDiscountToOrderDetails(parseFloat(discount));
    }
  });

  const handleEdit = (index) => {
    // Check if repairDetails exists and has items
    if (
      !orderDetails ||
      !Array.isArray(orderDetails) ||
      orderDetails.length === 0
    ) {
      console.warn("No repair details available for editing");
      return;
    }

    // Check if the index is valid
    if (index < 0 || index >= orderDetails.length) {
      console.warn(
        `Invalid index ${index} for orderDeatils array of length ${orderDetails.length}`
      );
      return;
    }

    const item = orderDetails[index];

    // Check if item exists and has required properties
    if (!item) {
      console.warn(`Item at index ${index} is undefined`);
      return;
    }
    if (item.vendor_id !== null && item.vendor_id !== undefined) {
      setIsVendor(true);
    } else {
      setIsVendor(false);
    }

    setEditIndex(index);

    const pieceCost = parseFloat(item.pieace_cost) || 0;
    const qty = parseFloat(item.qty) || 1;
    const pieceTaxableAmt = parseFloat(item.piece_taxable_amt || 0).toFixed(2);

    setFormData((prevFormData) => ({
      ...prevFormData,
      ...item,
      date: getTodayDate(),
      pieace_cost: pieceCost > 0 ? pieceCost.toFixed(2) : "",
      rate_type:item.rate_type,
      rate:
        item.rate && parseFloat(item.rate) > 0
          ? parseFloat(item.rate).toFixed(2)
          : "",
      piece_taxable_amt: pieceTaxableAmt,
      client_visibility: item.client_visibility || "Internal Facing",
    }));
  };
  const refreshOrderData = () => {
    setOldSalesData([]);
    setSchemeSalesData([]);
    setOrderDetails([]);
    setPaymentDetails({
      cash_amount: 0,
      card_amt: 0,
      chq: "",
      chq_amt: 0,
      online: "",
      online_amt: 0,
    });
    setOldTableData([]); // Clear the oldTableData state
    setSchemeTableData([]);
    setDiscount(0);
    // setSalesReturnData([]);
    setSelectedRows([]);
    setIsAllSelected(false);
    setReturnData({
      invoice_number: "",
    });
    localStorage.removeItem("oldSalesData");
    localStorage.removeItem("schemeSalesData");
    localStorage.removeItem(`orderDetails`);
    localStorage.removeItem(`paymentDetails`);
    localStorage.removeItem(`oldTableData`);
    localStorage.removeItem(`schemeTableData`);
    localStorage.removeItem(`discount`);
    localStorage.removeItem(`salesReturnData`);

    window.location.reload();
  };

  const handleUpdate = () => {
    if (!validateFields()) {
      return;
    }

    const wasManualLocked = isManualNetPayableSet;
    const updatedDetails = orderDetails.map((item, index) => {
      if (index === editIndex) {
        // Create the updated product with proper formatting
        const updatedProduct = {
          ...formData,
          pieace_cost:
            formData.pieace_cost && parseFloat(formData.pieace_cost) > 0
              ? parseFloat(formData.pieace_cost).toFixed(2)
              : null,
          rate:
            formData.rate && parseFloat(formData.rate) > 0
              ? parseFloat(formData.rate).toFixed(2)
              : "",
          imagePreview: formData.imagePreview,
          client_visibility: formData.client_visibility,
        };
        return updatedProduct;
      }
      return item;
    });

    setOrderDetails(updatedDetails);

    // Save to localStorage to persist the updated data
    localStorage.setItem(`orderDetails`, JSON.stringify(updatedDetails));

    setEditIndex(null);
    resetProductFields();

    // Exit manual-net mode to prevent compounded discount after edits
    setIsManualNetMode(false);
    setManualNetAmount(0);
    setIsManualNetPayableSet(false);
    setSavedNetPayableAmount(0);

    // Make net payable amount editable when product is updated
    if (setNetPayableEditableRef.current) {
      setNetPayableEditableRef.current();
    }

    // Apply festival discount to all products if offers are available
    if (offers.length > 0 || appliedOffersFromAPI.length > 0) {
      applyFestivalDiscountToAllProducts();
    }

    // If manual net payable had been locked previously, clear the discount
    // so it doesn't stack with the newly updated product
    if (wasManualLocked) {
      setDiscount(0);
      applyDiscountToOrderDetails(0);
    } else if (discount !== "" && !isNaN(parseFloat(discount))) {
      // Otherwise, re-apply existing percentage uniformly
      applyDiscountToOrderDetails(parseFloat(discount));
    }
  };

  const handleDelete = (indexToDelete) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      const wasManualLocked = isManualNetPayableSet;
      setOrderDetails(
        orderDetails.filter((_, index) => index !== indexToDelete)
      );
      alert("Product deleted successfully");

      // Exit manual-net mode to prevent compounded discount after deletion
      setIsManualNetMode(false);
      setManualNetAmount(0);
      setIsManualNetPayableSet(false);
      setSavedNetPayableAmount(0);

      // Make net payable amount editable when product is deleted
      if (setNetPayableEditableRef.current) {
        setNetPayableEditableRef.current();
      }

      // If manual net payable had been locked previously, clear the discount
      // so it doesn't stack after deletion
      if (wasManualLocked) {
        setDiscount(0);
        applyDiscountToOrderDetails(0);
      } else if (discount !== "" && !isNaN(parseFloat(discount))) {
        // Otherwise, re-apply existing percentage uniformly
        applyDiscountToOrderDetails(parseFloat(discount));
      }
    }
  };

  // const handleAdd = () => {
  //   setOrderDetails((prevDetails) => {
  //     const updatedDetails = [
  //       ...prevDetails,
  //       {
  //         ...formData,
  //         imagePreview: formData.imagePreview,
  //       },
  //     ];
  //     return updatedDetails;
  //   });
  //   // Reset the relevant fields
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     disscount: "",
  //     disscount_percentage: "",
  //   }));

  //   resetProductFields();
  // };

  // const handleEdit = (index) => {
  //   setEditIndex(index);
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     ...orderDetails[index], // Merge repair details into formData
  //   }));
  // };

  // const handleUpdate = () => {
  //   const updatedDetails = orderDetails.map((item, index) =>
  //     index === editIndex ? { ...formData } : item
  //   );
  //   setOrderDetails(updatedDetails);
  //   setEditIndex(null);
  //   resetProductFields();
  // };

  // const handleDelete = (indexToDelete) => {
  //   if (window.confirm("Are you sure you want to delete this item?")) {
  //     setOrderDetails(
  //       orderDetails.filter((_, index) => index !== indexToDelete)
  //     );
  //     alert("Product deleted successfully");
  //   }
  // };

  const resetProductFields = () => {
    setFormData((prev) => ({
      ...prev,
      code: "",
      product_id: "",
      metal: "",
      product_name: "",
      metal_type: "",
      design_name: "",
      purity: "",
      category: "",
      sub_category: "",
      gross_weight: "",
      stone_weight: "",
      weight_bw: "",
      stone_price: "",
      va_on: "Gross Weight",
      va_percent: "",
      wastage_weight: "",
      total_weight_av: "",
      mc_on: "MC %",
      mc_per_gram: "",
      making_charges: "",
      rate_type: "Fixed",
      rate: "",
      rate_amt: "",
      tax_percent: "",
      tax_amt: "",
      hm_charges: "60.00",
      total_price: "",
      qty: "",
      imagePreview: null,
      remarks: "",
      size: "",
      reservation_status: "",
      remarks_type: "",
      order_status: "In Progress",
      festival_discount: "",
      refund_amount: null,
    }));
  };

  const totalPrice = orderDetails.reduce(
    (sum, item) => sum + parseFloat(item.total_price || 0),
    0
  );

  const [oldTableData, setOldTableData] = useState(() => {
    const savedData = localStorage.getItem("oldTableData");
    return savedData ? JSON.parse(savedData) : [];
  });

  const [schemeTableData, setSchemeTableData] = useState(() => {
    const savedData = localStorage.getItem("schemeTableData");
    return savedData ? JSON.parse(savedData) : [];
  });

  const resetForm = () => {
    setFormData({
      customer_id: "",
      mobile: "",
      account_name: "",
      email: "",
      address1: "",
      address2: "",
      city: "",
      pincode: "",
      state: "",
      state_code: "",
      aadhar_card: "",
      gst_in: "",
      pan_card: "",
      date: "",
      order_number: "",
    });
    setPaymentDetails({
      cash_amount: 0,
      card_amt: 0,
      chq: "",
      chq_amt: 0,
      online: "",
      online_amt: 0,
    });
    setAdvanceEntries([]);
    setNewAdvanceEntries([]);
    setNewAdvance({
      amount: "",
      date: getTodayDate(),
      paymentMethod: "",
    });
  };

  const [selectedRows, setSelectedRows] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);

  const handleCheckboxChange = (event, index) => {
    if (!invoiceDetails.length) return;

    const isChecked = event.target.checked;
    let updatedSelectedRows = isChecked
      ? [...selectedRows, index]
      : selectedRows.filter((i) => i !== index);

    setSelectedRows(updatedSelectedRows);
    setIsAllSelected(updatedSelectedRows.length === invoiceDetails.length);
  };

  const handleSelectAllChange = (event) => {
    if (!invoiceDetails.length) return;

    const isChecked = event.target.checked;
    setSelectedRows(isChecked ? invoiceDetails.map((_, index) => index) : []);
    setIsAllSelected(isChecked);
  };

  const handleCheckout = async () => {
    if (!invoiceDetails.length || !selectedRows.length) {
      // alert("No invoices selected for sale return.");
      return;
    }

    try {
      const selectedInvoices = selectedRows.map(
        (rowIndex) => invoiceDetails[rowIndex]
      );

      const repairDetailsUpdates = selectedInvoices.map((invoice) => ({
        id: invoice.id,
        status: "Sale Returned",
      }));

      const openTagsUpdates = selectedInvoices.map((invoice) => ({
        PCode_BarCode: invoice.code,
        Status: "Sale Returned",
      }));

      const productUpdates = selectedInvoices.map((invoice) => ({
        product_id: invoice.product_id,
        qty: invoice.qty,
        gross_weight: invoice.gross_weight,
      }));

      const codesForAvailableEntries = selectedInvoices.map(
        (invoice) => invoice.code
      );

      // Execute all API calls in parallel
      const responses = await Promise.allSettled([
        axios.post(`${baseURL}/updateRepairDetails`, {
          updates: repairDetailsUpdates,
        }),
        axios.post(`${baseURL}/updateOpenTags`, { updates: openTagsUpdates }),
        axios.post(`${baseURL}/updateProduct`, { updates: productUpdates }),
        axios.post(`${baseURL}/addAvailableEntry`, {
          codes: codesForAvailableEntries,
        }),
      ]);

      // Check if any API failed
      const failedRequests = responses.filter(
        (res) => res.status === "rejected"
      );
      if (failedRequests.length > 0) {
        console.error("Some API calls failed:", failedRequests);
        alert("Some updates failed. Please check console for details.");
      } else {
        alert("Sale Return added Successfully!");
      }
    } catch (error) {
      console.error("Error during checkout:", error);
      alert("An error occurred during checkout. Please try again.");
    }
  };

  const salesTaxableAmount = selectedRows.reduce((sum, rowIndex) => {
    const detail = invoiceDetails[rowIndex];
    const stonePrice = parseFloat(detail.stone_price) || 0;
    const makingCharges = parseFloat(detail.making_charges) || 0;
    const rateAmt = parseFloat(detail.rate_amt) || 0;
    const itemDiscount = parseFloat(detail.disscount) || 0;
    const itemFestivalDiscount = parseFloat(detail.festival_discount) || 0;
    return (
      sum +
      stonePrice +
      makingCharges +
      rateAmt -
      itemDiscount -
      itemFestivalDiscount
    );
  }, 0);

  const salesTaxAmount = selectedRows.reduce((sum, rowIndex) => {
    const detail = invoiceDetails[rowIndex];
    return sum + parseFloat(detail.tax_amt || 0);
  }, 0);

  const salesNetAmount = salesTaxableAmount + salesTaxAmount;
  // const totalSalesReturnAmount =
  //   selectedRows.length > 0
  //     ? salesNetAmount // Use current selection for new sales returns
  //     : salesReturnData && salesReturnData.length > 0
  //     ? salesReturnData.reduce(
  //         (sum, item) => sum + parseFloat(item.total_price || 0),
  //         0
  //       )
  //     : 0;

  const isSameMonth = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    return (
      date.getMonth() === now.getMonth() &&
      date.getFullYear() === now.getFullYear()
    );
  };

  const allSelectedRowsAreThisMonth = selectedRows.every((rowIndex) =>
    isSameMonth(invoiceDetails[rowIndex]?.date)
  );

  const salesAmountToPass = allSelectedRowsAreThisMonth
    ? salesNetAmount
    : salesTaxableAmount;

  const handleBack = () => {
    // navigate("/orderstable");
    navigate("/dashboard");
  };

  // const handleAddCustomer = () => {
  //   navigate("/customermaster", { state: { from: "/orders" } });
  // };

  const handleAddCustomer = (mobile) => {
    console.log("handleAddCustomer received mobile:", mobile);
    navigate("/customermaster", {
      state: {
        from: `/orders`,
        mobile: mobile, // Pass the mobile number here
      },
    });
  };
  // Reset manual flag when URD data changes to allow automatic net payable updates
  //   useEffect(() => {
  //     if (oldSalesData.length > 0) {
  //       setIsManualNetPayableSet(false);
  //     }
  //   }, [oldSalesData]);

  // const totalAmount = orderDetails.reduce((sum, item) => {
  //   const stonePrice = parseFloat(item.stone_price) || 0;
  //   const makingCharges = parseFloat(item.making_charges) || 0;
  //   const rateAmt = parseFloat(item.rate_amt) || 0;
  //   const hmCharges = parseFloat(item.hm_charges) || 0;
  //   return sum + stonePrice + makingCharges + rateAmt + hmCharges;
  // }, 0);

  // const discountAmt = orderDetails.reduce((sum, item) => {
  //   const itemDiscount = parseFloat(item.disscount) || 0;
  //   const itemFestivalDiscount = parseFloat(item.festival_discount) || 0;
  //   return sum + itemDiscount + itemFestivalDiscount;
  // }, 0);

  // const taxableAmount = totalAmount - discountAmt;
  // const taxAmount = orderDetails.reduce(
  //   (sum, item) => sum + parseFloat(item.tax_amt || 0),
  //   0
  // );
  // const netAmount = taxableAmount + taxAmount;

  // const oldItemsAmount = location.state?.old_exchange_amt
  //   ? parseFloat(location.state.old_exchange_amt)
  //   : oldSalesData.reduce(
  //       (sum, item) => sum + parseFloat(item.total_amount || 0),
  //       0
  //     );

  // const schemeAmount = location.state?.scheme_amt
  //   ? parseFloat(location.state.scheme_amt)
  //   : schemeSalesData.reduce(
  //       (sum, item) => sum + parseFloat(item.paid_amount || 0),
  //       0
  //     );

  // const [advanceAmount, setAdvanceAmount] = useState(advance_amt);

  // // Calculate Net Payable Amount
  // const payableAmount =
  //   netAmount -
  //   (schemeAmount + oldItemsAmount + salesAmountToPass + advanceAmount);
  // const netPayableAmount = Math.round(payableAmount);

  // const clearData = () => {
  //   setOldSalesData([]);
  //   setSchemeSalesData([]);
  //   setOrderDetails([]);
  //   setPaymentDetails({
  //     cash_amount: 0,
  //     card_amt: 0,
  //     chq: "",
  //     chq_amt: 0,
  //     online: "",
  //     online_amt: 0,
  //   });
  //   setOldTableData([]);
  //   setSchemeTableData([]);
  //   localStorage.removeItem("oldSalesData");
  //   localStorage.removeItem("schemeSalesData");
  //   localStorage.removeItem("orderDetails");
  //   localStorage.removeItem("paymentDetails");
  //   localStorage.removeItem("oldTableData");
  //   localStorage.removeItem("schemeTableData");
  //   localStorage.removeItem(`discount`);
  // };
  useEffect(() => {
    if (oldSalesData.length > 0) {
      setIsManualNetPayableSet(false);
    }
  }, [oldSalesData]);

  let totalAmount = 0;
  let discountAmt = 0;
  let festivalDiscountAmt = 0;
  let taxableAmount = 0;
  let taxAmount = 0;
  let netAmount = 0;
  let discountPercent = 0;
  let totalMakingCharges = 0;
  let totalPieceCost = 0;
  let hasWeightBasedItems = false;
  

  if (
    isManualNetMode &&
    typeof manualNetAmount !== "undefined" &&
    manualNetAmount > 0
  ) {
    // Step 1: Compute totalAmount, makingCharges, pieceCost
    console.log("manual net before", manualNetAmount);
    orderDetails.forEach((item) => {
      const pricing = item.pricing;

      if (pricing === "By Weight") {
        const stonePrice = parseFloat(item.stone_price) || 0;
        const makingCharges = parseFloat(item.making_charges) || 0;
        const rateAmt = parseFloat(item.rate_amt) || 0;
        const hmCharges = parseFloat(item.hm_charges) || 0;
        totalAmount += stonePrice + makingCharges + rateAmt + hmCharges;

        totalMakingCharges += makingCharges;
        hasWeightBasedItems = true;
      } else {
        const pieceCost = parseFloat(item.pieace_cost) || 0;
        const qty = parseFloat(item.qty) || 0;
        const itemTotal = pieceCost * qty;
        totalAmount += itemTotal;
        totalPieceCost += itemTotal;
      }
    });

    // Step 2: Reverse tax and discount calculation from netAmount
    let cumulativeTaxable = 0;
    let cumulativeTax = 0;
    let totalFestivalDiscount = 0;

    orderDetails.forEach((item) => {
      const pricing = item.pricing;
      const itemTaxPercent = parseFloat(item.tax_percent) || 0;
      const itemFestivalDiscount = parseFloat(item.festival_discount) || 0;
      totalFestivalDiscount += itemFestivalDiscount;

      let itemTotal = 0;
      if (pricing === "By Weight") {
        const stonePrice = parseFloat(item.stone_price) || 0;
        const makingCharges = parseFloat(item.making_charges) || 0;
        const rateAmt = parseFloat(item.rate_amt) || 0;
        const hmCharges = parseFloat(item.hm_charges) || 0;
        itemTotal = stonePrice + makingCharges + rateAmt + hmCharges;
      } else {
        const pieceCost = parseFloat(item.pieace_cost) || 0;
        const qty = parseFloat(item.qty) || 0;
        itemTotal = pieceCost * qty;
      }

      const itemShare = itemTotal / totalAmount;
      const itemNet = manualNetAmount * itemShare;
      const itemTaxable = itemNet / (1 + itemTaxPercent / 100);
      const itemTax = itemNet - itemTaxable;

      cumulativeTaxable += itemTaxable;
      cumulativeTax += itemTax;
    });

    taxableAmount = cumulativeTaxable;
    taxAmount = cumulativeTax;
    netAmount = manualNetAmount;
    festivalDiscountAmt = totalFestivalDiscount;

    discountAmt = totalAmount - taxableAmount - totalFestivalDiscount;

    const discountBase = totalMakingCharges + totalPieceCost;
    discountPercent = discountBase ? (discountAmt * 100) / discountBase : 0;

    const roundedDiscount = parseFloat(discountPercent.toFixed(2));
    if (roundedDiscount !== discount) {
      setDiscount(roundedDiscount);
      localStorage.setItem(`discount`, roundedDiscount.toString());
      applyDiscountToOrderDetails(roundedDiscount);
    }
    console.log("manualNetAmount:", manualNetAmount);
    console.log("netPayableAmount:", taxableAmount);
    console.log("totalAmount:", totalAmount);
  } else {
    // FORWARD CALCULATION
    orderDetails.forEach((item) => {
      const pricing = item.pricing;
      const itemDiscount = parseFloat(item.disscount) || 0;
      const itemFestivalDiscount = parseFloat(item.festival_discount) || 0;
      const itemTaxPercent = parseFloat(item.tax_percent) || 0;

      let itemTotal = 0;
      if (pricing === "By Weight") {
        const stonePrice = parseFloat(item.stone_price) || 0;
        const makingCharges = parseFloat(item.making_charges) || 0;
        const rateAmt = parseFloat(item.rate_amt) || 0;
        const hmCharges = parseFloat(item.hm_charges) || 0;

        itemTotal = stonePrice + makingCharges + rateAmt + hmCharges;
        totalAmount += itemTotal;
        totalMakingCharges += makingCharges;
        hasWeightBasedItems = true;
      } else {
        const pieceCost = parseFloat(item.pieace_cost) || 0;
        const qty = parseFloat(item.qty) || 0;

        itemTotal = pieceCost * qty;
        totalAmount += itemTotal;
        totalPieceCost += itemTotal;
      }

      const totalDiscount = itemDiscount + itemFestivalDiscount;
      const itemTaxable = itemTotal - totalDiscount;
      const taxAmt = (itemTaxable * itemTaxPercent) / 100;

      discountAmt += itemDiscount;
      festivalDiscountAmt += itemFestivalDiscount;

      taxableAmount += itemTaxable;
      taxAmount += taxAmt;
      netAmount += itemTaxable + taxAmt;
    });

    const discountBase = totalMakingCharges + totalPieceCost;
    discountPercent = discountBase ? (discountAmt * 100) / discountBase : 0;
  }
  

  // Calculate discount percentage when loading existing order data
  useEffect(() => {
    if (orderDetails && orderDetails.length > 0 && discountAmt > 0 && !discount) {
      // Calculate total making charges and piece cost for discount base
      let totalMakingCharges = 0;
      let totalPieceCost = 0;

      orderDetails.forEach((item) => {
        const pricing = item.pricing;
        if (pricing === "By Weight") {
          const makingCharges = parseFloat(item.making_charges) || 0;
          totalMakingCharges += makingCharges;
        } else {
          const pieceCost = parseFloat(item.pieace_cost) || 0;
          const qty = parseFloat(item.qty) || 0;
          const itemTotal = pieceCost * qty;
          totalPieceCost += itemTotal;
        }
      });

      const discountBase = totalMakingCharges + totalPieceCost;
      if (discountBase > 0) {
        const calculatedDiscountPercent = (discountAmt * 100) / discountBase;
        setDiscount(calculatedDiscountPercent);
      }
    }
  }, [orderDetails, discountAmt, discount]);
  const oldItemsAmount = location.state?.old_exchange_amt
    ? parseFloat(location.state.old_exchange_amt)
    : oldSalesData.reduce(
        (sum, item) => sum + parseFloat(item.total_amount || 0),
        0
      );

  const schemeAmount = location.state?.scheme_amt
    ? parseFloat(location.state.scheme_amt)
    : schemeSalesData.reduce(
        (sum, item) => sum + parseFloat(item.paid_amount || 0),
        0
      );
  const [advanceAmount, setAdvanceAmount] = useState(advance_amt);
  
  // Debug advance amount calculation and sync advanceAmount state
  useEffect(() => {
    const totalAdvanceFromEntries = [...advanceEntries, ...newAdvanceEntries].reduce(
      (sum, entry) => sum + (parseFloat(entry.amount) || 0),
      0
    );
    
    // Ensure advanceAmount is always a number, not an array
    const currentAdvanceAmount = typeof advanceAmount === 'number' ? advanceAmount : 0;
    
    // Sync advanceAmount state with calculated total
    if (totalAdvanceFromEntries !== currentAdvanceAmount) {
      setAdvanceAmount(totalAdvanceFromEntries);
    }
    
  }, [advanceEntries, newAdvanceEntries, advanceAmount]);
  // --- Manual Net Amount ---
  const handleManualNetAmountChange = (value) => {
    setManualNetAmount(value);
    setIsManualNetMode(true); // Enter manual net amount mode
  };

  // --- Manual Net Pay Amount ---
  const handleManualNetPayAmountChange = (value) => {
    setManualNetPayAmount(value);
    setIsManualNetMode(true);

    // Calculate total amount without discounts
    let totalAmountWithoutDiscounts = 0;
    let totalMakingCharges = 0;
    let totalPieceCost = 0;

    orderDetails.forEach((item) => {
      const pricing = item.pricing;

      if (pricing === "By Weight") {
        const stonePrice = parseFloat(item.stone_price) || 0;
        const makingCharges = parseFloat(item.making_charges) || 0;
        const rateAmt = parseFloat(item.rate_amt) || 0;
        const hmCharges = parseFloat(item.hm_charges) || 0;

        totalAmountWithoutDiscounts +=
          stonePrice + makingCharges + rateAmt + hmCharges;
        totalMakingCharges += makingCharges;
      } else {
        const pieceCost = parseFloat(item.pieace_cost) || 0;
        const qty = parseFloat(item.qty) || 0;
        const itemTotal = pieceCost * qty;
        totalAmountWithoutDiscounts += itemTotal;
        totalPieceCost += itemTotal;
      }
    });

    // --- Check deductions ---
    const hasDeductions =
      oldItemsAmount > 0 ||
      schemeAmount > 0 ||
      salesAmountToPass > 0 ||
      numericAdvanceAmount > 0;

    if (hasDeductions) {
      const targetNetAmount =
        value +
        oldItemsAmount +
        schemeAmount +
        salesAmountToPass +
        numericAdvanceAmount;

      const discountAmount = Math.max(0, netAmount - targetNetAmount);

      const discountBase = totalMakingCharges + totalPieceCost;
      const discountPercent =
        discountBase > 0 ? (discountAmount * 100) / discountBase : 0;

      const roundedDiscount = parseFloat(discountPercent.toFixed(2));
      const finalDiscount = Math.max(0, roundedDiscount);

      if (finalDiscount !== discount) {
        setDiscount(finalDiscount);
        localStorage.setItem(`discount`, finalDiscount.toString());
        applyDiscountToOrderDetails(finalDiscount, true);
      }

      setManualNetAmount(targetNetAmount);
    } else {
      const calculatedNetAmount = value;

      let totalTaxableAmount = 0;
      let totalTaxAmount = 0;

      orderDetails.forEach((item) => {
        const pricing = item.pricing;
        const itemTaxPercent = parseFloat(item.tax_percent) || 0;
        const itemFestivalDiscount = parseFloat(item.festival_discount) || 0;

        let itemTotal = 0;
        if (pricing === "By Weight") {
          const stonePrice = parseFloat(item.stone_price) || 0;
          const makingCharges = parseFloat(item.making_charges) || 0;
          const rateAmt = parseFloat(item.rate_amt) || 0;
          const hmCharges = parseFloat(item.hm_charges) || 0;
          itemTotal = stonePrice + makingCharges + rateAmt + hmCharges;
        } else {
          const pieceCost = parseFloat(item.pieace_cost) || 0;
          const qty = parseFloat(item.qty) || 0;
          itemTotal = pieceCost * qty;
        }

        const itemShare = itemTotal / totalAmountWithoutDiscounts;
        const itemNet = calculatedNetAmount * itemShare;

        const itemTaxableBeforeFestival = itemNet / (1 + itemTaxPercent / 100);
        const itemTaxable = Math.max(
          0,
          itemTaxableBeforeFestival - itemFestivalDiscount
        );
        const itemTax = itemTaxable * (itemTaxPercent / 100);

        totalTaxableAmount += itemTaxable;
        totalTaxAmount += itemTax;
      });

      const totalAfterFestivalDiscount =
        totalAmountWithoutDiscounts - festivalDiscountAmt;
      const requiredDiscountAmount =
        totalAfterFestivalDiscount - totalTaxableAmount;

      const discountBase = totalMakingCharges + totalPieceCost;
      const discountPercent = discountBase
        ? (requiredDiscountAmount * 100) / discountBase
        : 0;

      const roundedDiscount = parseFloat(discountPercent.toFixed(2));

      if (roundedDiscount !== discount) {
        setDiscount(roundedDiscount);
        localStorage.setItem(`discount`, roundedDiscount.toString());
        applyDiscountToOrderDetails(roundedDiscount, true);
      }

      setManualNetAmount(calculatedNetAmount);
    }
  };

  // --- Manual Net Payable ---
  const handleManualNetPayableChange = (newNetPayableAmount) => {
    const totalDeductions =
      oldItemsAmount + schemeAmount + salesAmountToPass + numericAdvanceAmount;
    const expectedNetPayable = netAmount - totalDeductions;

    const tolerance = 1;
    if (newNetPayableAmount - expectedNetPayable > tolerance) {
      alert(
        `Net Payable (${newNetPayableAmount}) cannot exceed calculated (${expectedNetPayable}).`
      );
      return false;
    }

    const targetNetAmount = newNetPayableAmount + totalDeductions;
    setManualNetAmount(targetNetAmount);
    setIsManualNetMode(true);

    setSavedNetPayableAmount(newNetPayableAmount);
    setIsManualNetPayableSet(true);

    return true;
  };

  // --- Payable Amount Calculation ---
  // Ensure advanceAmount is always a number for calculations
  const numericAdvanceAmount = typeof advanceAmount === 'number' ? advanceAmount : 0;
  
  const hasDeductions =
    oldItemsAmount > 0 ||
    schemeAmount > 0 ||
    salesAmountToPass > 0 ||
    numericAdvanceAmount > 0;

  const calculatedNetPayable =
    netAmount -
    (schemeAmount + oldItemsAmount + salesAmountToPass + numericAdvanceAmount);


  let payableAmount;
  if (isManualNetPayableSet) {
    payableAmount = savedNetPayableAmount;
  } else if (hasDeductions) {
    payableAmount = calculatedNetPayable;
  } else if (isManualNetMode) {
    payableAmount = manualNetPayAmount;
  } else {
    payableAmount = netAmount;
  }

  const netPayableAmount = Math.round(payableAmount);

  const clearData = () => {
    setOldSalesData([]);
    setSchemeSalesData([]);
    setOrderDetails([]);
    setPaymentDetails({
      cash_amount: 0,
      card_amt: 0,
      chq: "",
      chq_amt: 0,
      online: "",
      online_amt: 0,
    });
    setOldTableData([]);
    setSchemeTableData([]);
    localStorage.removeItem("oldSalesData");
    localStorage.removeItem("schemeSalesData");
    localStorage.removeItem("orderDetails");
    localStorage.removeItem("paymentDetails");
    localStorage.removeItem("oldTableData");
    localStorage.removeItem("schemeTableData");
    localStorage.removeItem(`discount`);
  };

  const handleClear = () => {
    // Only clear product-related fields, preserve customer details
    setFormData((prevFormData) => ({
      // Preserve customer-related fields
      customer_id: prevFormData.customer_id,
      account_name: prevFormData.account_name,
      mobile: prevFormData.mobile,
      email: prevFormData.email,
      address1: prevFormData.address1,
      address2: prevFormData.address2,
      city: prevFormData.city,
      pincode: prevFormData.pincode,
      state: prevFormData.state,
      state_code: prevFormData.state_code,
      aadhar_card: prevFormData.aadhar_card,
      gst_in: prevFormData.gst_in,
      pan_card: prevFormData.pan_card,
      customerImage: prevFormData.customerImage,
      invoice_number: prevFormData.invoice_number,
      
      // Clear only product-related fields
      code: "",
      product_id: "",
      metal: "",
      product_name: "",
      metal_type: "",
      design_name: "",
      purity: "",
      pricing: "By Weight",
      category: "",
      sub_category: "",
      gross_weight: "",
      stone_weight: "",
      weight_bw: "",
      stone_price: "",
      va_on: "Gross Weight",
      va_percent: "",
      wastage_weight: "",
      total_weight_av: "",
      mc_on: "MC %",
      disscount_percentage: "",
      disscount: "",
      mc_per_gram: "",
      making_charges: "",
      rate: "",
      pieace_cost: "",
      mrp_price: "",
      rate_amt: "",
      tax_percent: "03% GST",
      tax_amt: "",
      hm_charges: "60.00",
      total_price: "",
      transaction_status: "Sales",
      qty: "1",
      opentag_id: "",
      product_image: null,
      imagePreview: null,
      remarks: "",
      sale_status: "Delivered",
      estimate_status: "Not Delivered",
      custom_purity: "",
      selling_purity: "",
      rate_type: "Fixed",
      size: "",
      remarks_type: "",
      order_status: "In Progress",
      reservation_status: "Not Reserved",
      refund_amount: null,
    }));
    setEditIndex(null);
    clearImage();
    console.log("Product form cleared successfully - customer details preserved");
  };
  useEffect(() => {}, [
    totalAmount,
    taxableAmount,
    taxAmount,
    netAmount,
    discountAmt,
    festivalDiscountAmt,
  ]);

  const handleSave = async (e, page = "orders", skipPDF = false) => {
    if (e) e.preventDefault();

    if (!formData.account_name || !formData.mobile) {
      alert("Please select the Customer");
      mobileRef.current?.focus();
      return false;
    }

    if (!orderDetails || orderDetails.length === 0) {
      alert("Please add at least one product before saving");
      return false;
    }

    try {
      setSaveLoading(true);
      const allItemsAreNew = orderDetails.every((item) => item.id === "");
      let updatedFormData = { ...formData };

      if (allItemsAreNew) {
        const response = await axios.get(`${baseURL}/lastInvoiceNumber`);
        const latestInvoiceNumber = response.data.lastInvoiceNumber;

        // updatedFormData.invoice_number = latestInvoiceNumber;
        setFormData((prev) => ({
          ...prev,
          invoice_number: latestInvoiceNumber,
        }));
      }

      const dataToSave = {
        orderDetails: orderDetails.map((item) => ({
          ...item,
          invoice_number: updatedFormData.invoice_number,
          customer_id: updatedFormData.customer_id,
          mobile: updatedFormData.mobile,
          account_name: updatedFormData.account_name,
          email: updatedFormData.email,
          address1: updatedFormData.address1,
          address2: updatedFormData.address2,
          city: updatedFormData.city,
          pincode: updatedFormData.pincode,
          state: updatedFormData.state,
          state_code: updatedFormData.state_code,
          aadhar_card: updatedFormData.aadhar_card,
          gst_in: updatedFormData.gst_in,
          pan_card: updatedFormData.pan_card,
          terms: updatedFormData.terms,
          cash_amount: paymentDetails.cash_amount || 0,
          card_amt: paymentDetails.card_amt || 0,
          chq_amt: paymentDetails.chq_amt || 0,
          online_amt: paymentDetails.online_amt || 0,
          chq: "",
          chq_amt: 0,
          online: "",
        })),
        oldItems: oldSalesData || [],
        memberSchemes: schemeSalesData || [],
        oldItemsAmount: oldItemsAmount || 0,
        schemeAmount: schemeAmount || 0,
        salesNetAmount: salesAmountToPass || 0,
        advanceAmount: JSON.stringify([...advanceEntries, ...newAdvanceEntries] || []),
        customerImage: customerImage || null,
      };

      console.log("Data being sent to backend:", dataToSave);
      const response = await axios.post(
        `${baseURL}/save-order-details`,
        dataToSave
      );
      alert(
        `Order added successfully. Order number: ${updatedFormData.order_number}`
      );

      clearData();
      resetForm();
      if (!skipPDF && updatedFormData.order_number) {
        const encodedOrderNumber = encodeURIComponent(updatedFormData.order_number);
        window.open(`/pdf/order/${encodedOrderNumber}`, "_blank", "noopener,noreferrer");
      }
      return true;
    } catch (error) {
      console.error("Error saving data:", error);
      alert("Error saving data");
      return false;
    }
    finally{
      setSaveLoading(false);
    }
  };

  const resetSaleReturnForm = () => {
    setReturnData({
      invoice_number: "",
    });
  };

  return (
    <div className="main-container">
      <Container className="sales-form-container-orders">
        <Form>
          <div className="sales-form">
            <div className="sales-form-left">
              <CustomerDetails
                formData={formData}
                setFormData={setFormData}
                handleCustomerChange={handleCustomerChange}
                handleAddCustomer={handleAddCustomer}
                customers={customers}
                setSelectedMobile={setSelectedMobile}
                customerImage={customerImage}
                setCustomerImage={setCustomerImage}
                mobileRef={mobileRef}
              />
            </div>
            <div className="sales-form-right">
              <InvoiceDetails
                formData={formData}
                setFormData={setFormData}
                currentOrderIndex={currentOrderIndex}
                totalOrders={sortedOrders.length}
                onPrev={navigateToPreviousOrder}
                onNext={navigateToNextOrder}
                onFirst={navigateToFirstOrder}
                onLast={navigateToLastOrder}
              />
            </div>
          </div>

          <div className="sales-form-section" style={{ marginTop: "-20px" }}>
            <ProductDetails
              formData={formData}
              handleChange={handleChange}
              handleBarcodeChange={handleBarcodeChange}
              handleProductChange={handleProductChange}
              handleProductNameChange={handleProductNameChange}
              handleMetalTypeChange={handleMetalTypeChange}
              handleDesignNameChange={handleDesignNameChange}
              handleAdd={handleAdd}
              products={products}
              data={data}
              uniqueProducts={uniqueProducts}
              categoryOptions={categoryOptions}
              subcategoryOptions={subcategoryOptions}
              purityOptions={purityOptions}
              designOptions={designOptions}
              metaltypeOptions={metaltypeOptions}
              filteredMetalTypes={filteredMetalTypes}
              filteredPurityOptions={filteredPurityOptions}
              filteredDesignOptions={filteredDesignOptions}
              isBarcodeSelected={isBarcodeSelected}
              isQtyEditable={isQtyEditable}
              handleUpdate={handleUpdate}
              isEditing={editIndex !== null}
              isVendor={isVendor}
              handleImageUpload={handleImageUpload}
              handleImageChange={handleImageChange}
              image={image}
              fileInputRef={fileInputRef}
              clearImage={clearImage}
              captureImage={captureImage}
              setShowWebcam={setShowWebcam}
              showWebcam={showWebcam}
              webcamRef={webcamRef}
              setShowOptions={setShowOptions}
              showOptions={showOptions}
              handleClear={handleClear}
            />
          </div>

          <div className="sales-form-section">
            <ProductTable
              orderDetails={orderDetails}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          </div>

          <div className="sales-form2">
            <div className="sales-form-third">
              <SalesFormSection
                metal={metal}
                setMetal={setMetal}
                setOldSalesData={setOldSalesData}
                oldTableData={oldTableData}
                setOldTableData={setOldTableData}
                setSchemeSalesData={setSchemeSalesData}
                schemeTableData={schemeTableData}
                setSchemeTableData={setSchemeTableData}
                orderDetails={orderDetails}
                selectedMobile={formData.mobile}
                setFilteredInvoices={setFilteredInvoices}
                uniqueInvoice={uniqueInvoice}
                setUniqueInvoice={setUniqueInvoice}
                invoiceDetails={invoiceDetails}
                setInvoiceDetails={setInvoiceDetails}
                handleInvoiceChange={handleInvoiceChange}
                returnData={returnData}
                setReturnData={setReturnData}
                filteredInvoices={filteredInvoices}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                isAllSelected={isAllSelected}
                setIsAllSelected={setIsAllSelected}
                handleCheckboxChange={handleCheckboxChange}
                handleSelectAllChange={handleSelectAllChange}
                salesTaxableAmount={salesTaxableAmount}
                salesTaxAmount={salesTaxAmount}
                salesNetAmount={salesNetAmount}
                resetSaleReturnForm={resetSaleReturnForm}
                handleCheckout={handleCheckout}
              />
            </div>

            <div className="sales-form-fourth">
              <PaymentDetails
                saving={saveLoading}
                setSaveLoading={setSaveLoading}
                paymentDetails={paymentDetails}
                setPaymentDetails={setPaymentDetails}
                advanceEntries={advanceEntries}
                setAdvanceEntries={setAdvanceEntries}
                newAdvanceEntries={newAdvanceEntries}
                setNewAdvanceEntries={setNewAdvanceEntries}
                newAdvance={newAdvance}
                setNewAdvance={setNewAdvance}
                handleSave={handleSave}
                formData={formData}
                handleBack={handleBack}
                totalPrice={totalPrice}
                orderDetails={orderDetails}
                taxableAmount={taxableAmount}
                discountAmt={discountAmt}
                totalAmount={totalAmount}
                taxAmount={taxAmount}
                netAmount={netAmount}
                oldItemsAmount={oldItemsAmount}
                schemeAmount={schemeAmount}
                netPayableAmount={netPayableAmount}
                oldSalesData={oldSalesData}
                schemeSalesData={schemeSalesData}
                salesNetAmount={salesNetAmount}
                salesAmountToPass={salesAmountToPass}
                salesTaxableAmount={salesTaxableAmount}
                discount={discount}
                handleDiscountChange={handleDiscountChange}
                setAdvanceAmount={setAdvanceAmount}
                advanceAmount={advanceAmount}
                savedNetPayableAmount={savedNetPayableAmount}
                setSavedNetPayableAmount={setSavedNetPayableAmount}
                setIsManualNetPayableSet={setIsManualNetPayableSet}
                festivalShowModal={festivalShowModal}
                handleFestivalShowModal={handleFestivalShowModal}
                handleFestivalCloseModal={handleFestivalCloseModal}
                appliedOffers={appliedOffers}
                setAppliedOffers={setAppliedOffers}
                festivalDiscountAmt={festivalDiscountAmt}
                manualNetAmount={manualNetAmount}
                setManualNetAmount={setManualNetAmount}
                handleManualNetAmountChange={handleManualNetAmountChange}
                isManualNetMode={isManualNetMode}
                setIsManualNetMode={setIsManualNetMode}
                handleManualNetPayAmountChange={handleManualNetPayAmountChange}
                manualNetPayAmount={manualNetPayAmount}
                handleManualNetPayableChange={handleManualNetPayableChange}
                handleApply={handleApply}
                isAnyOfferApplied={isAnyOfferApplied}
                applyDiscountAmountToOrderDetails={
                  applyDiscountAmountToOrderDetails
                }
                selectedRows={selectedRows}
                setNetPayableEditable={setNetPayableEditableRef}
              />
            </div>
          </div>
          {showPDFDownload && (
            <PDFDownloadLink
              document={
                <Salesorderform
                  formData={formData}
                  orderDetails={orderDetails}
                  paymentDetails={paymentDetails}
                  discountAmt={discountAmt}
                  festivalDiscountAmt={festivalDiscountAmt}
                />
              }
              fileName={`order-${formData.order_number}.pdf`}
            >
              {({ blob, url, loading, error }) =>
                loading ? "Generating PDF..." : "Download Invoice PDF"
              }
            </PDFDownloadLink>
          )}
        </Form>
      </Container>
    </div>
  );
};

export default SalesForm;
